import { InstantAnswerBuilderFn } from "@faire/help-center-self-serve/types";

import {
  MessageRetailerOrBrandButton,
  SELF_SERVE_GENERAL_DESCRIPTION_WITH_CONTEXT,
  SELF_SERVE_GENERAL_TITLE_WITH_CONTEXT,
  additionalDataRequiredForContactingRetailerOrBrandCTA,
} from "../../shared/instantAnswerUtils";

export const GeneralContactBrandIA: InstantAnswerBuilderFn = (
  strictLocalize
) => {
  return {
    titleBuilder: (context) => {
      return SELF_SERVE_GENERAL_TITLE_WITH_CONTEXT(strictLocalize, context);
    },
    descriptionBuilder: (context) => {
      const description = SELF_SERVE_GENERAL_DESCRIPTION_WITH_CONTEXT(
        strictLocalize,
        context
      );
      if (!description) {
        return [];
      }
      return [description];
    },
    primaryCtaBuilder: {
      textBuilder: (context) => {
        return MessageRetailerOrBrandButton(context, strictLocalize)?.label;
      },
      onClickFunctionBuilder: (context) => {
        return MessageRetailerOrBrandButton(context, strictLocalize)?.onClick;
      },
    },
    additionalRequiredData:
      additionalDataRequiredForContactingRetailerOrBrandCTA(),
  };
};
